import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";
import { ConfirmationService } from "@jaspero/ng2-confirmations";
import { ResolveEmit } from "@jaspero/ng2-confirmations/src/interfaces/resolve-emit";
import { ModalDirective } from "ngx-bootstrap";

import { GUID } from "app/brightserve/brightserve.module";
import { Medication, SlimScrollOptions } from "app/shared/shared.module";

import { AddonService } from "app/add-ons/addon.service";
@Component({
    selector: 'app-addon-medication',
    templateUrl: './addon-medication.component.html',
    styleUrls: ['./addon-medication.component.css']
})
export class AddonMedicationComponent implements OnInit {

    MedicinesFilter: string;
    Medications: Medication[];
    NewMedication: Medication = Medication.BlankMedication();
    MedicationTypeList: string[] = ["Controlled Drug", "Prescription only Medicine", "Over the Counter", "Other"];

    SlimScrollOptions = SlimScrollOptions;

    GetMedicationSubscription: Subscription;
    SaveMedicationSubscription: Subscription;
    RemoveMedicationSubscription: Subscription;

    @Input() PatientId: GUID;
    @Input() EnableAdd: boolean = false;
    @Input() EnableDelete: boolean = false;
    @Input() EnableEdit: boolean = false;

    CanEnableAdd: boolean = false;
    CanEnableDelete: boolean = false;
    CanEnableEdit: boolean = false;

    @ViewChild('MedicationModal') public modal: ModalDirective

    constructor(private addonService: AddonService, private _confirmation: ConfirmationService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.CanEnableAdd = this.EnableAdd;
        this.CanEnableDelete = this.EnableDelete;
        this.CanEnableEdit = this.EnableEdit;
    }

    ngOnChanges() {
        if (this.PatientId) {
            this.GetMedications();
            this.EnableAdd = this.CanEnableAdd;
            this.EnableDelete = this.CanEnableDelete;
            this.EnableEdit = this.CanEnableEdit;
        }
        else {
            this.EnableAdd = false;
            this.EnableDelete = false;
            this.EnableEdit = false;
        }
    }

    ngOnDestroy() {
        if (this.GetMedicationSubscription != null)
            this.GetMedicationSubscription.unsubscribe();
        if (this.SaveMedicationSubscription != null)
            this.SaveMedicationSubscription.unsubscribe();
        if (this.RemoveMedicationSubscription != null)
            this.RemoveMedicationSubscription.unsubscribe();
    }

    GetMedications() {
        this.MedicinesFilter = "";
        if (this.PatientId) {
            this.GetMedicationSubscription = this.addonService.GetMedicationsForPatient(this.PatientId).subscribe(
                medications => {
                    this.Medications = medications;
                }, err => {
                    this._notification.error("Data Error", "Medication data for this patient could not be obtained.");
                }
            );
        }
    };

    OpenModal(medication: Medication) {
        if (!medication)
            this.NewMedication = Medication.BlankMedication();
        else
            this.NewMedication = new Medication(medication);
        this.modal.show();
    }

    SaveNewMedication() {
        this.NewMedication.Type.Entity = "Medication";
        this.NewMedication.Type.Field = "Type";
        this.SaveMedicationSubscription = this.addonService.AddMedicationToPatient(this.PatientId, this.NewMedication).subscribe(
            data => {
                this._notification.success("Save Success", "Your medication was saved successfully.");
                this.modal.hide();
                this.GetMedications();
            }, err => {
                this._notification.error("Save Error", "Your medication was not saved successfully.");
            }
        );
    };

    RemoveMedicationToPatient(event, medication: Medication) {
        event.stopPropagation();
        this._confirmation.create('Remove Medication?', 'Are you sure you want to remove this medication?')
            .subscribe((ans: ResolveEmit) => ans.resolved ? this.RemoveMedication(medication) : null);
    };

    private RemoveMedication(medication: Medication) {
        this.RemoveMedicationSubscription = this.addonService.RemoveMedicationToPatient(medication.Id).subscribe(
            data => {
                this._notification.success("Remove Success", "Your medication was removed successfully.");
                this.GetMedications();
            }, err => {
                this._notification.error("Remove Error", "Your medication was not removed successfully.");
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/app/add-ons/medication/addon-medication.component.ts